import Logo from 'public/logo.svg'

export const HEADER = {
  logo: {
    href: '/',
    title: <Logo />,
    alt: 'Karan0805 Logo',
  },
  nav: [
    {
      href: '/',
      title: 'Home',
      alt: 'Country roads..',
      desktop: true,
    },
    {
      href: '/#about',
      title: 'About',
      alt: 'More about me.',
      desktop: true,
    },
    {
      href: '/#portfolio',
      title: 'Portfolio',
      alt: "Work I've done.",
      desktop: true,
    },
    {
      href: '/resume',
      title: 'Resume',
      alt: 'My professional resume',
      desktop: true,
    },
    {
      href: 'https:/www.syntaxwork.com/contact',
      title: 'Contact',
      alt: 'Contact us',
      desktop: false,
    },
  ],
  profileNav: [],
}
